import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export const CheckoutSection = () => {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 19999;
  const bump1Price = 10000;
  const bump2Price = 10000;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  return <Section id="compra" darker data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-white" data-id="element-18">
          Lo que llevás con cada opción
        </h2>

        <div className="bg-night-900 border-2 border-accent-blue rounded-3xl p-6 md:p-10 mb-8 shadow-2xl" data-id="element-19">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 border-b border-night-700 pb-8" data-id="element-20">
            <div data-id="element-21">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-22">
                OPCIÓN 1 — SISTEMA BASE
              </h3>
              <div className="text-gray-400 line-through text-xl" data-id="element-23">$39.000</div>
              <div className="text-4xl font-bold text-cta" data-id="element-24">$19.999</div>
            </div>
            <div className="mt-6 md:mt-0" data-id="element-25">
              <Button href="Link de tu checkout" className="w-full md:w-auto" data-id="element-26">
                QUIERO EL SISTEMA BASE — $19.999
              </Button>
            </div>
          </div>

          <div className="space-y-4 mb-8" data-id="element-27">
            <div className="flex items-center gap-3" data-id="element-28">
              <CheckCircle2 className="text-accent-blue w-5 h-5" data-id="element-29" />
              <span className="text-gray-200" data-id="element-30">
                Los 6 tomos del sistema Apagá la Cabeza y Dormite
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-31">
              <CheckCircle2 className="text-accent-blue w-5 h-5" data-id="element-32" />
              <span className="text-gray-200" data-id="element-33">Los 3 bonus exclusivos</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-34">
              <CheckCircle2 className="text-accent-blue w-5 h-5" data-id="element-35" />
              <span className="text-gray-200" data-id="element-36">Acceso inmediato en PDF</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-37">
              <CheckCircle2 className="text-accent-blue w-5 h-5" data-id="element-38" />
              <span className="text-gray-200" data-id="element-39">
                Basado en el Método Apagón Mental
              </span>
            </div>
          </div>
          <p className="text-gray-400 italic" data-id="element-40">
            90 hojas de sistema completo para apagar la cabeza y dormirte
          </p>
        </div>

        {/* Order Bump 1 */}
        <div className={`border-2 rounded-2xl p-6 md:p-8 mb-6 transition-colors ${bump1 ? 'border-cta bg-cta/5' : 'border-night-700 bg-night-800'}`} data-id="element-41">
          <div className="flex items-start gap-4" data-id="element-42">
            <input type="checkbox" id="bump1" className="mt-1.5 w-6 h-6 accent-cta cursor-pointer" checked={bump1} onChange={e => setBump1(e.target.checked)} data-id="element-43" />
            <div className="flex-1" data-id="element-44">
              <label htmlFor="bump1" className="cursor-pointer block" data-id="element-45">
                <div className="text-cta font-bold text-sm tracking-wider mb-1" data-id="element-46">
                  ➕ ORDER BUMP 1
                </div>
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-47">
                  GUÍA DE RESCATE NOCTURNO
                </h4>
                <div className="text-gray-400 mb-4" data-id="element-48">
                  + $10.000 → Total: $
                  {(basePrice + bump1Price).toLocaleString('es-AR')}
                </div>
              </label>

              <div className="text-gray-300 space-y-4 text-sm md:text-base" data-id="element-49">
                <p className="font-bold text-white" data-id="element-50">
                  QUÉ HACER CUANDO NO PODÉS DORMIR
                </p>
                <p data-id="element-51">
                  La guía de emergencia para usar en el momento exacto en que no
                  podés bajar.
                </p>
                <p className="font-medium text-white" data-id="element-52">Incluye:</p>
                <ul className="space-y-2 pl-2" data-id="element-53">
                  <li data-id="element-54">✅ 7 secciones organizadas por tipo de problema</li>
                  <li data-id="element-55">✅ Protocolo ultra rápido de 3 minutos</li>
                  <li data-id="element-56">✅ Checklist maestra para seguir sin pensar</li>
                  <li data-id="element-57">✅ Frases de emergencia listas para usar</li>
                  <li data-id="element-58">✅ Registro de noches difíciles</li>
                  <li data-id="element-59">✅ 20 hojas de guía de acción inmediata</li>
                </ul>
                <p className="font-medium text-white mt-4" data-id="element-60">Para quién es:</p>
                <p data-id="element-61">
                  Para la persona que quiere tener TODO listo para cuando la
                  noche se complique. Sin improvisar. Sin buscar qué hacer. Sin
                  pensar. Solo abrir y seguir los pasos.
                </p>
                <p className="italic text-gray-400" data-id="element-62">
                  "Si esta noche me vuelve a pasar, quiero tener esto."
                </p>
                <p className="text-gray-500 line-through" data-id="element-63">
                  Valor real: $12.000
                </p>
                <p className="text-accent-light font-medium" data-id="element-64">
                  Lo agregás hoy por solo $10.000 más
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Order Bump 2 */}
        <div className={`border-2 rounded-2xl p-6 md:p-8 mb-12 transition-colors ${bump2 ? 'border-cta bg-cta/5' : 'border-night-700 bg-night-800'}`} data-id="element-65">
          <div className="flex items-start gap-4" data-id="element-66">
            <input type="checkbox" id="bump2" className="mt-1.5 w-6 h-6 accent-cta cursor-pointer" checked={bump2} onChange={e => setBump2(e.target.checked)} data-id="element-67" />
            <div className="flex-1" data-id="element-68">
              <label htmlFor="bump2" className="cursor-pointer block" data-id="element-69">
                <div className="text-cta font-bold text-sm tracking-wider mb-1" data-id="element-70">
                  ➕➕ ORDER BUMP 2
                </div>
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-71">
                  SISTEMA ANTI RECAÍDA
                </h4>
                <div className="text-gray-400 mb-4" data-id="element-72">
                  + $10.000 → Total: $
                  {(basePrice + bump2Price).toLocaleString('es-AR')}
                </div>
              </label>

              <div className="text-gray-300 space-y-4 text-sm md:text-base" data-id="element-73">
                <p className="font-bold text-white" data-id="element-74">
                  POR QUÉ NO PODÉS APAGAR LA CABEZA Y CÓMO FRENARLO
                </p>
                <p data-id="element-75">
                  La guía premium para dejar de llegar a la noche con la cabeza
                  explotada.
                </p>
                <p className="font-medium text-white" data-id="element-76">Incluye:</p>
                <ul className="space-y-2 pl-2" data-id="element-77">
                  <li data-id="element-78">
                    ✅ Los 8 patrones que más cargan tu cabeza identificados
                  </li>
                  <li data-id="element-79">✅ Tu perfil de carga personal</li>
                  <li data-id="element-80">✅ Técnicas específicas para cada patrón</li>
                  <li data-id="element-81">✅ Plan de descarga diurna</li>
                  <li data-id="element-82">
                    ✅ Cómo cerrar el día de trabajo para no seguir pensando
                  </li>
                  <li data-id="element-83">
                    ✅ El mapa de tu día para identificar picos de tensión
                  </li>
                  <li data-id="element-84">✅ Plan semanal de descarga mental</li>
                  <li data-id="element-85">
                    ✅ 20 hojas de sistema para atacar el problema desde la raíz
                  </li>
                </ul>
                <p className="font-medium text-white mt-4" data-id="element-86">Para quién es:</p>
                <p data-id="element-87">
                  Para la persona que no quiere solo zafar esta noche. Que
                  quiere entender por qué termina todas las noches igual. Y
                  frenarlo antes de que llegue a la cama.
                </p>
                <p className="italic text-gray-400" data-id="element-88">
                  "No quiero solo apagar el incendio. Quiero que no vuelva a
                  haber incendio."
                </p>
                <p className="text-gray-500 line-through" data-id="element-89">
                  Valor real: $15.000
                </p>
                <p className="text-accent-light font-medium" data-id="element-90">
                  Lo agregás hoy por solo $10.000 más
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-91">
          <h3 className="text-2xl font-bold text-white mb-6" data-id="element-92">
            RESUMEN DE LO QUE LLEVÁS
          </h3>
          <div className="overflow-x-auto" data-id="element-93">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-94">
              <thead data-id="element-95">
                <tr className="border-b border-night-700 bg-night-900/50" data-id="element-96">
                  <th className="py-4 px-4 text-gray-400 font-semibold" data-id="element-97"></th>
                  <th className="py-4 px-4 text-white font-semibold text-center" data-id="element-98">
                    BASE
                  </th>
                  <th className="py-4 px-4 text-white font-semibold text-center" data-id="element-99">
                    BASE + RESCATE
                  </th>
                  <th className="py-4 px-4 text-cta font-bold text-center" data-id="element-100">
                    BASE + RESCATE + ANTI RECAÍDA
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-night-700/50" data-id="element-101">
                <tr data-id="element-102">
                  <td className="py-3 px-4 text-gray-300" data-id="element-103">
                    6 Tomos del sistema
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-104">✅</td>
                  <td className="py-3 px-4 text-center" data-id="element-105">✅</td>
                  <td className="py-3 px-4 text-center" data-id="element-106">✅</td>
                </tr>
                <tr data-id="element-107">
                  <td className="py-3 px-4 text-gray-300" data-id="element-108">
                    3 Bonus exclusivos
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-109">✅</td>
                  <td className="py-3 px-4 text-center" data-id="element-110">✅</td>
                  <td className="py-3 px-4 text-center" data-id="element-111">✅</td>
                </tr>
                <tr data-id="element-112">
                  <td className="py-3 px-4 text-gray-300" data-id="element-113">
                    Guía de rescate nocturno
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-114">❌</td>
                  <td className="py-3 px-4 text-center" data-id="element-115">✅</td>
                  <td className="py-3 px-4 text-center" data-id="element-116">✅</td>
                </tr>
                <tr data-id="element-117">
                  <td className="py-3 px-4 text-gray-300" data-id="element-118">
                    Sistema anti recaída
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-119">❌</td>
                  <td className="py-3 px-4 text-center" data-id="element-120">❌</td>
                  <td className="py-3 px-4 text-center" data-id="element-121">✅</td>
                </tr>
                <tr className="bg-night-800/30" data-id="element-122">
                  <td className="py-3 px-4 text-gray-400" data-id="element-123">Total de hojas</td>
                  <td className="py-3 px-4 text-center text-gray-400" data-id="element-124">90</td>
                  <td className="py-3 px-4 text-center text-gray-400" data-id="element-125">110</td>
                  <td className="py-3 px-4 text-center text-gray-400" data-id="element-126">130</td>
                </tr>
                <tr className="bg-night-800/50" data-id="element-127">
                  <td className="py-3 px-4 text-gray-400" data-id="element-128">Valor real</td>
                  <td className="py-3 px-4 text-center text-gray-400 line-through" data-id="element-129">
                    $39.000
                  </td>
                  <td className="py-3 px-4 text-center text-gray-400 line-through" data-id="element-130">
                    $51.000
                  </td>
                  <td className="py-3 px-4 text-center text-gray-400 line-through" data-id="element-131">
                    $66.000
                  </td>
                </tr>
                <tr className="bg-night-900" data-id="element-132">
                  <td className="py-4 px-4 font-bold text-white" data-id="element-133">Precio hoy</td>
                  <td className="py-4 px-4 text-center font-bold text-white" data-id="element-134">
                    $19.999
                  </td>
                  <td className="py-4 px-4 text-center font-bold text-white" data-id="element-135">
                    $29.999
                  </td>
                  <td className="py-4 px-4 text-center font-bold text-cta text-xl" data-id="element-136">
                    $39.999
                  </td>
                </tr>
                <tr className="bg-accent-blue/10" data-id="element-137">
                  <td className="py-3 px-4 font-medium text-accent-light" data-id="element-138">
                    Lo que ahorrás
                  </td>
                  <td className="py-3 px-4 text-center font-medium text-accent-light" data-id="element-139">
                    $19.001
                  </td>
                  <td className="py-3 px-4 text-center font-medium text-accent-light" data-id="element-140">
                    $21.001
                  </td>
                  <td className="py-3 px-4 text-center font-medium text-accent-light" data-id="element-141">
                    $26.001
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center" data-id="element-142">
          <Button href="Link de tu checkout" fullWidth className="max-w-2xl mx-auto py-5 text-xl" data-id="element-143">
            COMPLETAR MI COMPRA POR ${total.toLocaleString('es-AR')}
          </Button>
        </div>
      </div>
    </Section>;
};